import { z } from "zod";
import { defineEvent } from "./_define";
import { baseEnvelopeSchema } from "./_envelope";

export const NPS_COMPLETED_VALUES = {
  PROMOTER: "promoter",
  PASSIVE: "passive",
  DETRACTOR: "detractor",
} as const;
export type NpsCompletedValue =
  (typeof NPS_COMPLETED_VALUES)[keyof typeof NPS_COMPLETED_VALUES];

const passthroughEnvelope = baseEnvelopeSchema.passthrough();

export const onboardingWelcomeContinue = defineEvent({
  eventName: "onboarding_welcome_continue",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: passthroughEnvelope,
});

export const triageRequestConfirmed = defineEvent({
  eventName: "triage_request_confirmed",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: passthroughEnvelope,
});

export const triageRequestCancelled = defineEvent({
  eventName: "triage_request_cancelled",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: passthroughEnvelope,
});

export const manageSubscription = defineEvent({
  eventName: "manage_subscription",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: passthroughEnvelope,
});

export const termsConditions = defineEvent({
  eventName: "terms_conditions",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: passthroughEnvelope,
});

export const contactSupport = defineEvent({
  eventName: "contact_support",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: passthroughEnvelope,
});

export const subCancelReactivate = defineEvent({
  eventName: "sub_cancel_reactivate",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: passthroughEnvelope,
});

export const paymentErrManage = defineEvent({
  eventName: "payment_err_manage",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: passthroughEnvelope,
});

export const shortlinkFollowed = defineEvent({
  eventName: "shortlink_followed",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: passthroughEnvelope,
});

export const npsCompleted = defineEvent({
  eventName: "nps_completed",
  eventVersion: 1,
  valueSchema: z
    .enum([
      NPS_COMPLETED_VALUES.PROMOTER,
      NPS_COMPLETED_VALUES.PASSIVE,
      NPS_COMPLETED_VALUES.DETRACTOR,
    ])
    .or(z.string())
    .optional(),
  metadataSchema: passthroughEnvelope,
});

export const uiDismissed = defineEvent({
  eventName: "ui_dismissed",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: passthroughEnvelope,
});
